/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Users_Needed_SubtitleInputs */



/**
* | output |
* | --- |
* | "Select the number of users to see accurate pricing" |
*
* @param {Pricing_Users_Needed_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_users_needed_subtitle = /** @type {((inputs?: Pricing_Users_Needed_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Users_Needed_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle die Anzahl der Nutzer, um die Preise genau anzuzeigen")
	return /** @type {LocalizedString} */ ("Select the number of users to see accurate pricing")
});